module.exports = __webpack_public_path__ + "img/syria.71141b29.png";